  <!-- Item qty edit (opened from grid Item Name click) -->
  <div class="item-qty" *ngIf="isItemMode">
    <div class="item-qty__header">
      <div class="item-qty__title">Item Quantities</div>
      <button type="button" class="item-qty__close" (click)="close()" aria-label="Close">×</button>
    </div>

    <div class="item-qty__body" *ngIf="itemEdit">
      <div class="item-qty__hero">
        <img *ngIf="itemImageUrl" class="item-qty__img" [src]="itemImageUrl" [alt]="itemDisplayName" width="150"
          height="150" />
        <div class="item-qty__meta">
          <div class="item-qty__name">{{ itemEdit?.itemName || '' }}</div>
          <div class="item-qty__subname" *ngIf="itemEdit?.teluguItemName">{{ itemEdit?.teluguItemName }}</div>
          <div class="item-qty__fusion" *ngIf="itemEdit?.itemFusionId">
            <span class="item-qty__fusion-label">Fusion Id</span>
            <span class="item-qty__fusion-value">{{ itemEdit?.itemFusionId }}</span>
          </div>
        </div>
      </div>

      <div class="item-qty__grid">
        <div class="item-qty__field item-qty__field--open-balance">
          <span>Open Balance Qty</span>
          <span class="item-qty__open-balance-value">{{ inrGroupedNumber(itemOpenBalance) }}</span>
        </div>
        <label class="item-qty__field">
          <span>Breakfast used Quantity</span>
          <input type="text" class="item-qty__input" inputmode="decimal" placeholder="0"
            [value]="bfQtyDisplay"
            (input)="onItemQtyInput('bfQty', $event)"
            (blur)="onItemQtyBlur('bfQty', $event)" />
        </label>
        <label class="item-qty__field">
          <span>Lunch used Quantity</span>
          <input type="text" class="item-qty__input" inputmode="decimal" placeholder="0"
            [value]="lunchQtyDisplay"
            (input)="onItemQtyInput('lunchQty', $event)"
            (blur)="onItemQtyBlur('lunchQty', $event)" />
        </label>
        <label class="item-qty__field">
          <span>Snacks used Quantity</span>
          <input type="text" class="item-qty__input" inputmode="decimal" placeholder="0"
            [value]="snacksQtyDisplay"
            (input)="onItemQtyInput('snacksQty', $event)"
            (blur)="onItemQtyBlur('snacksQty', $event)" />
        </label>
        <label class="item-qty__field">
          <span>Dinner used Quantity</span>
          <input type="text" class="item-qty__input" inputmode="decimal" placeholder="0"
            [value]="dinnerQtyDisplay"
            (input)="onItemQtyInput('DinnerQty', $event)"
            (blur)="onItemQtyBlur('DinnerQty', $event)" />
        </label>
        <button type="button" class="item-qty__submit item-qty__submit--full" (click)="submitItemQty()">Submit</button>
        <button type="button" class="item-qty__submit item-qty__remove item-qty__submit--full" *ngIf="canRemoveItem"
          (click)="removeItem()">Remove</button>
      </div>
    </div>

    <div class="item-qty__footer">
      <!-- <button type="button" class="item-qty__submit" (click)="submitItemQty()">Submit</button> -->
    </div>
  </div>
  <!-- loader -->
  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>